import api from './api';
import type { InventoryDashboard, InventoryItemType } from '../types/venue';

const inventoryDashboardService = {
  getDashboard: async (
    venueId: string,
    categoryId?: string | 'none',
    type?: InventoryItemType,
  ): Promise<InventoryDashboard> => {
    const params: Record<string, unknown> = {};
    if (categoryId) params.categoryId = categoryId;
    if (type) params.type = type;
    const response = await api.get(`/admin/venue/${venueId}/inventory/dashboard`, { params });
    return response.data;
  },
};

export default inventoryDashboardService;
